import React from 'react';

import { ApIcon, colors } from '@alixpartners/ui-components';
import { Tile, TileText, TileTitle, IconWrapper } from './UploadTypes.styles';
import { UPLOAD_TYPES } from '../utils';

export const UploadTypes = ({ onChange }) => {
	return (
		<React.Fragment>
			<Tile
				onClick={() => {
					onChange(UPLOAD_TYPES.APPEND);
				}}
			>
				<IconWrapper>
					<ApIcon
						iconName="append_outlined"
						iconColor={colors.grey3}
						iconSize={56}
					/>
				</IconWrapper>
				<TileTitle>Append data</TileTitle>
				<TileText>
					System will add rows in the upload file to the existing budget data.
				</TileText>
			</Tile>
			<Tile
				onClick={() => {
					onChange(UPLOAD_TYPES.OVERRIDE);
				}}
			>
				<IconWrapper>
					<ApIcon
						iconName="override_outlined"
						iconColor={colors.grey3}
						iconSize={56}
					/>
				</IconWrapper>
				<TileTitle>Override data</TileTitle>
				<TileText>
					System will replace all existing data with the new data from the file.
					<br />
					<span className="red">
						Current data will be lost and can not be restored in the future.
					</span>
				</TileText>
			</Tile>
		</React.Fragment>
	);
};
